import React from 'react';
import Configuration from '../Globals/Scripts/Configuration';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators';
import AutoScopeStyles from '../Utilities/Decorators/AutoScopeStylesDecorator';

class NotFoundView extends React.Component {

    render() {
        return (
                <div>
                    <div className="header">
                        <h1 id="page-heading">Page not found</h1>
                        <p>Sorry, we couldn't find what you were looking for</p>
                    </div>

                    <div className="causes-and-suggestions">
                        <div className="column">
                        <h2>Most likely causes</h2>
                        <ul>
                            <li>The page no longer exists or has moved</li>
                            <li>You may have typed in the incorrect page name</li>
                        </ul>
                        </div>
                        <div className="column">
                        <h2>What you can try</h2>
                        <ul>
                            <li>Make sure the requested URL is correct</li>
                            <li><a href="/Info/contact/contact/">Contact us</a> to let us know about the error</li>
                        </ul>
                        </div>
                    </div>
                </div>
            )
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(NotFoundView);
